// extracted by mini-css-extract-plugin
export var details = "_l3-0";
export var inspectorPopover = "_l3-1";